export default __webpack_public_path__ + "static/media/caseStudy.021584b0.png";